import { client, destroy, get, post } from '@/api/axios';
import { ExportEndpoints } from '@/api/endpoints/ExportEndpoints';
import { TaskEndpoints } from '@/api/endpoints/TaskEndpoints';
import { type ListData } from '@/app/models/ListData';
import { type TaskInfoDto } from '@/app/models/TaskInfoDto';

/** Tarefa finalizada some do backend em ~2 dias: uma página cobre tudo o que o menu tem para mostrar. */
const PAGE_SIZE = 50;

export const getTaskStatus = (taskName: string) => {
  return get<TaskInfoDto<string>>(TaskEndpoints.getStatus(taskName));
};

/**
 * Tarefas do usuário logado (o dono é sempre quem está logado, nunca um campo do filtro). É a fonte de verdade; o
 * SSE só acelera. A ordem é pedida aqui: sem `sort` o `/list` do backend ordena por id, não por data.
 */
export const listMyTasks = () =>
  post<ListData<TaskInfoDto<string>>>(TaskEndpoints.list, {
    sort: 'start_time',
    direction: 'DESC',
    page: 0,
    per_page: PAGE_SIZE,
  }).then((response) => response.data.content);

/** Dispensa uma tarefa finalizada. */
export const dismissTask = (taskName: string) => destroy(TaskEndpoints.dismiss(taskName));

export const clearFinishedTasks = () => destroy(TaskEndpoints.dismissFinished);

/** O resultado da exportação concluída é o id do anexo com o arquivo. */
export const fetchTaskFile = (task: TaskInfoDto<string>) =>
  client.get<Blob>(ExportEndpoints.file(task.result!), { responseType: 'blob' }).then((response) => response.data);
